import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from './http-data.service';

@Injectable()
export class NotificationsService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/messages');
  }

  // n1
  sendWelcomeStudentNotification(payload: any): Promise<any> {
    const { student, clientType, clientDisplayName } = payload;
    const notification = 'student_created';
    const url = `${this.baseUrl}/${notification}/send`;
    const notificationData = {
      email: student.email,
      lang: student.lang,
      clientDisplayName: clientDisplayName,
      userId: student.id,
      clientId: student.clientId,
      clientType: clientType,
      partnerId: student.distributorId,
      shouldSendWelcomeNotification: !student.selfRegistered
    };
    return super.postRequest(url, notificationData, { ...this.getRequestOptions(), responseType: 'text' });
  }

  // na1
  sendWelcomeAdminNotification(admin: any): Promise<any> {
    const notification = 'admin_created';
    const url = `${this.baseUrl}/${notification}/send`;
    const notificationData = {
      lang: admin.lang,
      email: admin.email,
      id: admin.id,
      role: admin.role,
      clientIds: admin.clientIds,
      isCreator: admin.isCreator,
      blocked: admin.blocked,
      distributorId: admin.distributorId
    };
    return super.postRequest(url, notificationData, { ...this.getRequestOptions(), responseType: 'text' });
  }

  // na7
  sendTechTestsNotification(payload: any): Promise<any> {
    const { client, emails } = payload;
    const notification = 'tech_tests';
    const url = `${this.baseUrl}/${notification}/send`;
    const notificationData = {
      client,
      emails
    };
    return super.postRequest(url, notificationData, { ...this.getRequestOptions(), responseType: 'text' });
  }

  sendBonusGroupCreatedNotification(payload: any): Promise<any> {
    const notification = 'bonus_group_created';
    const url = `${this.baseUrl}/${notification}/send`;
    const notificationData = {
      group: payload
    };
    return super.postRequest(url, notificationData, { ...this.getRequestOptions(), responseType: 'text' });
  }
}
